import { takeEvery, put, select } from 'redux-saga/effects';

import { getLogger } from '../../logger';

import { changeLocale } from './actions';
import { getLocale } from './selectors';

const logger = getLogger('intl');

let isInitialLocationChange = true;

function* locationChangeSaga({
  payload: {
    location: { pathname },
  },
}) {
  // eslint-disable-next-line no-undef
  if (!widget && !isInitialLocationChange) {
    const stateLocale = yield select(getLocale);
    let newLocale = stateLocale;
    if (pathname.startsWith('/de') || pathname.startsWith('/pl')) {
      newLocale = pathname.substr(1, 2);
    }

    logger.debug(
      'geändert Location change with: newLocale',
      newLocale,
      'stateLocale',
      stateLocale,
      'pathname',
      pathname
    );
    if (newLocale !== stateLocale) {
      yield put(changeLocale({ locale: newLocale }));
    }
  }
  isInitialLocationChange = false;
}

export function* watchIntlActions() {
  logger.debug('Setup saga watcher');
  yield takeEvery('@@router/LOCATION_CHANGE', locationChangeSaga);
}

export default [watchIntlActions];
